module.exports = __webpack_public_path__ + "img/ddl.40e36bcb.jpg";